export const createLocationString = (merchant: IMerchant): string => {
  return `${merchant?.street1}, ${merchant?.city}, ${merchant?.state}`;
};
